var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _path5, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path6, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _path7, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _path8, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _path9, _rect122, _rect123, _rect124, _rect125, _path10, _path11, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _path12, _path13, _path14, _rect154, _rect155, _rect156, _path15, _rect157, _rect158, _path16, _path17, _path18, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantummain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0212 22.3232C37.0933 20.2613 35.1804 19.2738 32.994 18.509C33.0004 18.4222 33.0048 18.3352 33.0073 18.2481C33.1198 16.412 32.1361 14.6525 30.4467 13.7598C29.4712 13.2445 28.1493 13.0063 27.1006 12.9684C26.9028 12.6761 26.7161 12.3692 26.5051 12.0878C25.1704 10.3089 22.9748 9.26427 20.6568 9.39006C17.8616 9.54166 15.4504 11.3524 14.5883 13.9469C13.098 13.0083 11.1777 12.9172 9.58266 13.7598C7.75835 14.7234 6.75308 16.7007 7.07134 18.6981C3.97855 19.119 1.61871 21.6055 1.42999 24.6423C1.20029 28.3311 3.93386 31.2062 7.70911 31.2062C8.8046 31.2095 25.9664 31.2119 26.9617 31.2151V32.6529C25.0625 32.6529 9.5959 32.592 7.70496 32.5863C5.59344 32.5799 3.58249 31.8175 2.11079 30.3261C0.582399 28.777 -0.116614 26.6889 0.0158222 24.5588C0.219028 21.2942 2.48575 18.5521 5.60751 17.6075C5.73415 15.5101 6.96001 13.5756 8.90723 12.5466C10.4447 11.7346 12.2479 11.5923 13.8736 12.1027C15.2211 9.74003 17.7353 8.16638 20.5781 8.01196C23.3254 7.86318 26.0262 9.11105 27.6486 11.2738C27.7396 11.3947 27.8253 11.5181 27.9089 11.6431C29.0151 11.76 30.1826 12.0503 31.1221 12.5466C33.0292 13.5542 34.2733 15.4814 34.4181 17.5639C36.5292 18.4146 38.3448 19.6036 39.3187 21.7692C39.7027 22.6235 39.9279 23.5392 39.9837 24.4701C40.1083 26.5446 39.5227 28.521 38.0526 30.0584C35.0977 33.1484 30.7935 32.6529 26.8755 32.6529C26.8755 32.6529 26.8755 31.5534 26.8755 31.2151L30.4558 31.2748C34.8647 31.2881 38.8675 29.5084 38.5696 24.5508C38.5236 23.7851 38.3386 23.0304 38.0212 22.3232Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0404 24.8185L21.2716 24.585V25.0521H20.8092L21.0404 24.8185Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1962 24.6626H22.6587V25.0519H22.1962L22.1962 24.6626Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8902 24.6626L23.1214 24.8573L23.3526 25.0519H22.8902L22.8902 24.6626Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 26.6099,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 27.2715,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8093,
    y: 25.2471,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 25.9087,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8093,
    y: 28.5952,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 29.9189,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8092,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 26.6099,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 27.2715,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 25.2471,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 25.9092,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 28.5952,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1962,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 26.6099,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 27.2715,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 25.2471,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 25.9092,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 28.5952,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8903,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8903,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8902,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 26.6099,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2776,
    y: 26.6099,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 27.2715,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2776,
    y: 27.2715,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 23.584,
    y: 25.2471,
    width: 0.308798,
    height: 0.467169,
    fill: "#111111"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2776,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 25.9087,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5837,
    y: 28.5952,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2776,
    y: 28.5952,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2777,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 29.9189,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2777,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5838,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2776,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 26.6094,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 27.272,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 25.2471,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5035 24.8188H21.9659V25.0524H21.5035V24.8188Z",
    fill: "#111111"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 25.9087,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 28.5952,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 29.9189,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5035,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 26.7256,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 27.3745,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0116 25.3896H26.3499V25.8477H26.0116L26.0116 25.3896Z",
    fill: "#111111"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 28.0229,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 26.0386,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 28.6719,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 29.3208,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 29.9697,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8962,
    y: 30.6187,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2559,
    y: 26.7251,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 27.374,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 25.3892,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 24.7402,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 24.1177,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4759 23.7168L27.7093 23.4946V23.9526H27.256L27.4759 23.7168Z",
    fill: "#111111"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 28.0229,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 26.0381,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 28.6719,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 29.3203,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2559,
    y: 29.9692,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 27.256,
    y: 30.6182,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 26.7251,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 27.3745,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 25.3892,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 24.7402,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 24.1177,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 23.4946,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9364,
    y: 23.0278,
    width: 0.45336,
    height: 0.311446,
    fill: "#111111"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 28.616,
    y: 25.3892,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 28.616,
    y: 24.7402,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 28.616,
    y: 24.1177,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 28.616,
    y: 23.4946,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 28.616,
    y: 23.0273,
    width: 0.45336,
    height: 0.311446,
    fill: "#111111"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2875,
    y: 25.3896,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2875,
    y: 24.7402,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2875,
    y: 24.1177,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2875,
    y: 23.4946,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2876,
    y: 23.0273,
    width: 0.45336,
    height: 0.311446,
    fill: "#111111"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 28.0225,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 26.0381,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 28.6719,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 29.3203,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 29.9692,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9365,
    y: 30.6182,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 26.7251,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2963,
    y: 26.7251,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 27.374,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2962,
    y: 27.374,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 28.0225,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2962,
    y: 28.0225,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6162,
    y: 26.0381,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2869,
    y: 26.0381,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 28.6714,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2963,
    y: 28.6714,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 29.3208,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2962,
    y: 29.3208,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 29.9692,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2962,
    y: 29.9692,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6163,
    y: 30.6182,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2963,
    y: 30.6182,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5761,
    y: 26.7256,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 26.576,
    y: 27.3745,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5761,
    y: 25.3896,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 26.576,
    y: 24.7412,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8073 24.3517L27.0294 24.1182V24.5762H26.576L26.8073 24.3517Z",
    fill: "#111111"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 26.576,
    y: 28.0234,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 26.576,
    y: 26.0386,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5761,
    y: 28.6719,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 26.576,
    y: 29.3208,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 26.576,
    y: 29.9697,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5761,
    y: 30.6187,
    width: 0.45336,
    height: 0.458009,
    fill: "#111111"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6455,
    y: 26.6094,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3397 26.6875L16.5709 26.8822L16.8021 27.0768H16.3397V26.6875Z",
    fill: "#111111"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6456,
    y: 27.271,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3397,
    y: 27.271,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6456,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3397,
    y: 27.9331,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0329 27.9326L17.2641 28.1662L17.4953 28.3998H17.0329V27.9326Z",
    fill: "#111111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8826 27.9326L18.6514 28.1662L18.4202 28.3998H18.8826V27.9326Z",
    fill: "#111111"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6456,
    y: 28.5947,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3397,
    y: 28.5947,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0329,
    y: 28.5947,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 18.8826 28.5947)",
    fill: "#111111"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7266,
    y: 28.5947,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6456,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3397,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0329,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 18.8826 29.2568)",
    fill: "#111111"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7266,
    y: 29.2568,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6456,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3397,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0329,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 18.8826 29.9185)",
    fill: "#111111"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7266,
    y: 29.9185,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6456,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3397,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 27.271)",
    fill: "#111111"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 26.6094)",
    fill: "#111111"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 27.9326)",
    fill: "#111111"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 28.5947)",
    fill: "#111111"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 29.2568)",
    fill: "#111111"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 29.9185)",
    fill: "#111111"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 19.5762 30.5806)",
    fill: "#111111"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0329,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 0.462428,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 18.8826 30.5806)",
    fill: "#111111"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7266,
    y: 30.5806,
    width: 0.462428,
    height: 0.467169,
    fill: "#111111"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5587,
    y: 26.6099,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2388 26.6875L11.4654 26.8822L11.6921 27.0768H11.2388V26.6875Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1771 28.8288L12.372 28.5952V29.0624H11.9844L12.1771 28.8288Z",
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1772 27.9326H12.4088V28.3998H12.1772V27.9326Z",
    fill: "#111111"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 13.7321 28.5952)",
    fill: "#111111"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 13.7321 27.9326)",
    fill: "#111111"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 13.7321 27.3101)",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7321 26.6763L13.2787 26.6763V27.0767H13.7321V26.6763Z",
    fill: "#111111"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5986,
    y: 28.5952,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5986,
    y: 27.9326,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5986 27.3101L13.0519 27.3101V27.7772H12.5986L12.5986 27.3101Z",
    fill: "#111111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2388 29.5682L11.6921 29.3735V29.7239H11.2388V29.5682Z",
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0117 29.5682L10.5584 29.3735V29.7239H11.0117V29.5682Z",
    fill: "#111111"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9187,
    y: 29.2568,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 13.7321 29.2568)",
    fill: "#111111"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5986,
    y: 29.2568,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5586,
    y: 29.9185,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2388,
    y: 29.9185,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9187,
    y: 29.9185,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 13.7321 29.9185)",
    fill: "#111111"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5986,
    y: 29.9185,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5586,
    y: 30.5806,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2388,
    y: 30.5806,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 27.2715)",
    fill: "#111111"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 26.6094)",
    fill: "#111111"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 27.9326)",
    fill: "#111111"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 28.5952)",
    fill: "#111111"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 29.2568)",
    fill: "#111111"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 29.9185)",
    fill: "#111111"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 14.4122 30.5806)",
    fill: "#111111"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9187,
    y: 30.5806,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 0.45336,
    height: 0.467169,
    transform: "matrix(-1 0 0 1 13.7321 30.5806)",
    fill: "#111111"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5986,
    y: 30.5806,
    width: 0.45336,
    height: 0.467169,
    fill: "#111111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0942 27.4227C11.2988 27.4227 11.4886 27.4849 11.6469 27.5916C12.276 26.9829 12.9052 26.3743 13.5346 25.7658C13.4433 25.6137 13.3909 25.4354 13.3909 25.2447C13.3909 24.6878 13.8377 24.2363 14.3889 24.2363C14.9404 24.2363 15.3872 24.6878 15.3872 25.2447C15.3872 25.3474 15.3718 25.4467 15.3437 25.5401C15.9594 25.8948 16.5753 26.2494 17.1913 26.6038C17.3738 26.4014 17.6365 26.2745 17.9288 26.2745C18.1368 26.2745 18.3298 26.3387 18.4896 26.4489C19.291 25.6889 20.0924 24.9289 20.8937 24.169C20.8055 24.0187 20.7551 23.8436 20.7551 23.6564C20.7551 23.0994 21.2019 22.648 21.753 22.648C22.3046 22.648 22.7513 23.0994 22.7513 23.6564C22.7511 23.7493 22.7392 23.8385 22.7155 23.9241C23.2211 24.215 23.7266 24.506 24.2319 24.7971C24.4144 24.5947 24.6771 24.4679 24.9695 24.4679C25.1774 24.4679 25.3704 24.5321 25.5302 24.6418C26.3316 23.8821 27.133 23.1223 27.9344 22.3623C27.8462 22.2121 27.7957 22.0369 27.7957 21.8497C27.7957 21.2928 28.2425 20.8413 28.7937 20.8413C29.3452 20.8413 29.792 21.2928 29.792 21.8497C29.792 22.4067 29.3452 22.8581 28.7937 22.8581C28.5861 22.8581 28.3931 22.7939 28.2333 22.6842C27.4319 23.4441 26.6305 24.204 25.8291 24.9637C25.9169 25.1139 25.9678 25.2891 25.9678 25.4763C25.9678 26.0332 25.5206 26.4847 24.9695 26.4847C24.4183 26.4847 23.9715 26.0332 23.9715 25.4763C23.9715 25.3735 23.9869 25.2739 24.015 25.1805C23.5133 24.8917 23.0116 24.6028 22.5099 24.3137C22.3269 24.529 22.0558 24.6648 21.753 24.6648C21.5454 24.6648 21.3525 24.6006 21.1926 24.4908C20.3912 25.2508 19.5899 26.0108 18.7885 26.7707C18.8767 26.9206 18.9271 27.0957 18.9271 27.2829C18.9271 27.8399 18.48 28.2917 17.9288 28.2917C17.3777 28.2917 16.9309 27.8399 16.9309 27.2829C16.9309 27.1802 16.9463 27.0809 16.9744 26.9871C16.3587 26.6327 15.7429 26.2782 15.1272 25.9235C14.9446 26.1262 14.6816 26.2531 14.3889 26.2531C14.1847 26.2531 13.9949 26.1912 13.8366 26.0846L11.9489 27.9103C12.0398 28.0625 12.0922 28.2407 12.0922 28.4315C12.0922 28.9884 11.6454 29.4399 11.0942 29.4399C10.5431 29.4399 10.0963 28.9884 10.0963 28.4315C10.0963 27.8745 10.5431 27.4227 11.0942 27.4227ZM24.9695 24.8633C24.6344 24.8633 24.3628 25.1377 24.3628 25.4763C24.3628 25.8149 24.6344 26.0893 24.9695 26.0893C25.3045 26.0893 25.5761 25.8149 25.5761 25.4763C25.5761 25.1377 25.3045 24.8633 24.9695 24.8633ZM28.7937 21.2367C28.459 21.2367 28.187 21.5111 28.187 21.8497C28.187 22.1883 28.459 22.4627 28.7937 22.4627C29.1287 22.4627 29.4007 22.1883 29.4007 21.8497C29.4007 21.5111 29.1287 21.2367 28.7937 21.2367ZM14.3889 24.6317C14.0542 24.6317 13.7822 24.9061 13.7822 25.2447C13.7822 25.5833 14.0542 25.8577 14.3889 25.8577C14.7239 25.8577 14.9955 25.5833 14.9955 25.2447C14.9955 24.9061 14.7239 24.6317 14.3889 24.6317ZM17.9288 26.6699C17.5941 26.6699 17.3222 26.9443 17.3222 27.2829C17.3222 27.6215 17.5941 27.8959 17.9288 27.8959C18.2639 27.8959 18.5354 27.6215 18.5354 27.2829C18.5354 26.9443 18.2639 26.6699 17.9288 26.6699ZM21.753 23.0434C21.4183 23.0434 21.1464 23.3178 21.1464 23.6564C21.1464 23.995 21.4183 24.2694 21.753 24.2694C22.0881 24.2694 22.36 23.995 22.36 23.6564C22.36 23.3178 22.0881 23.0434 21.753 23.0434ZM11.0942 27.8185C10.7592 27.8185 10.4876 28.0929 10.4876 28.4315C10.4876 28.7701 10.7592 29.0444 11.0942 29.0444C11.4293 29.0444 11.7009 28.7701 11.7009 28.4315C11.7009 28.0929 11.4293 27.8185 11.0942 27.8185Z",
    fill: "#111111"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3951 24.0219V19.36C14.3951 19.0335 14.1353 18.7661 13.8176 18.7661H11.119C10.8013 18.7661 10.5415 19.0335 10.5415 19.36V27.3409C10.7043 27.2549 10.8895 27.2063 11.0853 27.2063C11.2629 27.2063 11.4371 27.2467 11.5958 27.3242L13.226 25.7203C13.1647 25.5705 13.1329 25.409 13.1329 25.2447C13.1329 24.5683 13.6665 24.0195 14.3246 24.0195C14.3484 24.0195 14.3718 24.0203 14.3951 24.0219Z",
    fill: "#111111"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6517 25.4682L17.1342 26.3365C17.3462 26.1575 17.6124 26.0583 17.8907 26.0583C18.0725 26.0583 18.2501 26.1003 18.4117 26.1812L19.5053 25.1265V15.3981C19.5053 15.0716 19.2452 14.8042 18.9275 14.8042H16.2296C15.9119 14.8042 15.6517 15.0716 15.6517 15.3981V25.4682Z",
    fill: "#111111"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8394 12.5651V22.9513C21.0548 22.6368 21.4112 22.4313 21.8137 22.4313C22.4723 22.4313 23.0059 22.9801 23.0059 23.6565C23.0059 23.7092 23.0027 23.7614 22.9964 23.8133L24.2196 24.5298C24.3582 24.4127 24.5199 24.3298 24.6929 24.2862V12.5651C24.6929 12.2386 24.4331 11.9712 24.1154 11.9712H21.4169C21.0991 11.9712 20.8394 12.2386 20.8394 12.5651Z",
    fill: "#111111"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8726 24.0207L27.6417 22.3144C27.5834 22.1673 27.5531 22.0101 27.5531 21.8497C27.5531 21.1733 28.0866 20.6245 28.7447 20.6245C29.1518 20.6245 29.5111 20.8343 29.7262 21.1542V19.36C29.7262 19.0335 29.466 18.7661 29.1484 18.7661H26.4504C26.1328 18.7661 25.8726 19.0335 25.8726 19.36V24.0207Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantummain);
export default __webpack_public_path__ + "static/media/quantummain.3dbd3578e3a586b911a448bfd555d0f6.svg";
export { ForwardRef as ReactComponent };